import { LegalEntity } from '@mkp/legal-entity/models';
import { CompanyCategory } from '@mkp/tracking/models';
import { LegalEntityState } from '@mkp/shared/models';

export const getCompanyCategory = (legalEntity: LegalEntity): CompanyCategory => ({
  company_claim_verified: companyClaimVerified(legalEntity),
  company_employees_count: legalEntity.employeeCountTo,
  company_industry: legalEntity.industry['en'],
  company_location: legalEntity.address.city,
  company_name: legalEntity.name, //only for logged in B2B users ?? ,
  company_id: legalEntity.id,
});

export const companyClaimVerified = (legalEntity?: LegalEntity): 'y' | 'n' | undefined => {
  return legalEntity ? (legalEntity.state === LegalEntityState.Active ? 'y' : 'n') : undefined;
};
